import React from 'react';

interface FupXorProps {
  width?: number;
  height?: number;
}

const FupXor: React.FC<FupXorProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* Zusätzliche Linie für XOR */}
    <path d="M 5 10 Q 10 30 5 50" fill="none" stroke="#0D3559" strokeWidth="2" />
    
    {/* Baustein-Körper */}
    <path d="M 12 10 Q 22 30 12 50 L 42 50 Q 72 30 42 10 Z" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="20" r="3" fill="#0D3559" />
    <circle cx="5" cy="40" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="30" y="35" fontSize="16" fill="#0D3559" textAnchor="middle" fontWeight="bold">=1</text>
  </svg>
);

export default FupXor;
